import { eventBus } from 'EventBus/';

export const busName = 'videoPopIn';

export const videoPopin = {
  name: 'vch-video-popin',
  inserted: (el, binding) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      if (binding.value?.vid) {
        eventBus.$emit(`${busName}::open`, binding.value, el);
      }
    });
  },
};
